import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { iconOffsetMixin } from '../iconOffsetMixin';
import { marginMixin } from '../marginMixin';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';
export var DropdownHeadingMixin = function DropdownHeadingMixin(props) {
  return token({
    backgroundColor: 'DropdownHeading.backgroundColor',
    fontColor: 'DropdownHeading.fontColor',
    fontType: 'DropdownHeading.fontType',
    horizontalSpacing: 'DropdownHeading.horizontalSpacing',
    iconMarginRight: 'DropdownHeading.Icon.marginRight',
    iconSize: 'DropdownHeading.iconSize',
    margin: 'DropdownHeading.margin',
    verticalSpacing: 'DropdownHeading.verticalSpacing'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      iconMarginRight = _ref.iconMarginRight,
      iconSize = _ref.iconSize,
      verticalSpacing = _ref.verticalSpacing;
    return css(["", " ", " background-color:", ";box-sizing:border-box;color:", ";margin:0;padding:", "px ", "px;text-transform:uppercase;&:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}", " > ", "{color:", ";flex-shrink:0;margin-right:", ";}"], typographyMixin(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), iconOffsetMixin(Object.assign({}, props, {
      iconSize: iconSize
    })), backgroundColor, fontColor, verticalSpacing, horizontalSpacing, marginMixin(props), StyledIcon, fontColor, iconMarginRight ? iconMarginRight + "px" : spaceMixin('xs')(props));
  })(props);
};